// -- [Footer - links and copyright]

import type { FooterConfig } from '@/types/content'
import { DrivibleAnimatedLogo } from './DrivibleAnimatedLogo'

interface FooterProps {
  footer: FooterConfig
}

export function Footer({ footer }: FooterProps) {
  return (
    <footer className="py-8 px-6 bg-surface-subtle border-t border-line">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <DrivibleAnimatedLogo className="shrink-0" placement="footer" />
        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-sm text-ink-muted">
          <a
            href="/try"
            className="inline-flex items-center min-h-10 rounded-lg border-2 border-brand-orange px-3 py-1.5 font-semibold text-brand-orange transition-colors hover:bg-brand-orange/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange"
            data-umami-event="Footer - Try"
          >
            Try
          </a>
          {footer.links.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="hover:text-gray-900 transition-colors"
              data-umami-event={`Footer - ${link.label}`}
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
      <div className="max-w-6xl mx-auto mt-4 text-center md:text-left text-sm text-ink-muted">
        {footer.copyright}
      </div>
    </footer>
  )
}
